module.exports = __webpack_public_path__ + "static/media/watch-fitness.794da55c.svg";